export default __webpack_public_path__ + "static/media/2023_Januar_Wald.415155ae.webp";